var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import fetch from '../fetch/fetch';
import { METHOD } from '../fetch/types';
export const list = (token, featureName, payload = {}, sortArgument = null, pageIndex = 0) => __awaiter(void 0, void 0, void 0, function* () {
    const { status, response } = yield fetch(METHOD.GET, '/crud-interface/list', {
        token,
        featureName,
        payload,
        sortArgument,
        pageIndex,
    });
    if (status && response) {
        return response;
    }
    return false;
});
export const count = (token, featureName, payload = {}) => __awaiter(void 0, void 0, void 0, function* () {
    const { status, response } = yield fetch(METHOD.GET, '/crud-interface/count', {
        token,
        featureName,
        payload,
    });
    if (status && !isNaN(response)) {
        return response;
    }
    return false;
});
export const get = (token, featureName, payload = {}) => __awaiter(void 0, void 0, void 0, function* () {
    const { status, response } = yield fetch(METHOD.GET, '/crud-interface/get', {
        token,
        featureName,
        payload,
    });
    if (status && response) {
        return response;
    }
    return false;
});
export const create = (token, featureName, payload = {}) => __awaiter(void 0, void 0, void 0, function* () {
    const { status, response } = yield fetch(METHOD.POST, '/crud-interface/create', {
        token,
        featureName,
        payload,
    });
    if (status && response) {
        return response;
    }
    return false;
});
export const update = (token, featureName, payload = {}) => __awaiter(void 0, void 0, void 0, function* () {
    const { status, response } = yield fetch(METHOD.PUT, '/crud-interface/update', {
        token,
        featureName,
        payload,
    });
    if (status && response) {
        return response;
    }
    return false;
});
export const remove = (token, featureName, payload = {}) => __awaiter(void 0, void 0, void 0, function* () {
    const { status, response } = yield fetch(METHOD.DELETE, '/crud-interface/remove', {
        token,
        featureName,
        payload,
    });
    if (status) {
        return response;
    }
    return false;
});
export const upsert = (token, featureName, payload = {}) => __awaiter(void 0, void 0, void 0, function* () {
    const { status, response } = yield fetch(METHOD.PUT, '/crud-interface/upsert', {
        token,
        featureName,
        payload,
    });
    if (status && response) {
        return response;
    }
    return false;
});
export const multiUpsert = (token, featureName, payload = []) => __awaiter(void 0, void 0, void 0, function* () {
    const { status, response } = yield fetch(METHOD.PUT, '/crud-interface/multi-upsert', {
        token,
        featureName,
        payload,
    });
    if (status && response) {
        return response;
    }
    return false;
});
